(() => {
  const selectors = {
    mainAddToCartButton: '.ProductForm__BuyButtons',
    stickyAddToCartWrapper: '.ProductForm__sticky',
    stickyAddToCartButton: '.ProductForm__AddToCart',

    isVisibleClass: 'is-visible'
  };

  const addToCartButton = document.querySelector(selectors.mainAddToCartButton);
  const stickyAddToCartWrapper = document.querySelector(selectors.stickyAddToCartWrapper);
  const stickyAddToCartButton = stickyAddToCartWrapper.querySelector(selectors.stickyAddToCartButton);

  function isScrolledIntoView(el) {
    const rect = el.getBoundingClientRect();
    const elemTop = rect.top;
    const elemBottom = rect.bottom;
    const isVisible = elemBottom > window.innerHeight || (elemTop >= 0) && (elemBottom <= window.innerHeight);

    return isVisible;
  }

  stickyAddToCartButton.addEventListener('click', () => {
    addToCartButton.querySelector('button').click();
  });

  window.addEventListener('scroll', ()=>{
    if (!isScrolledIntoView(addToCartButton)) {
      stickyAddToCartWrapper.classList.add(selectors.isVisibleClass);
    } else {
      stickyAddToCartWrapper.classList.remove(selectors.isVisibleClass);
    }
  });
})()
